import { useAuthStore } from './auth-store';

export function isAuthenticated(): boolean {
  return useAuthStore.getState().status === 'authenticated';
}
